const findMetafieldValue = (namespace, key, metafields) => {
	return (metafields.find(item => item.namespace === namespace && item.key === key) || {}).value || '';
}

// Override Settings
var bcSfFilterSettings = {
	general: {
		limit: bcSfFilterConfig.custom.products_per_page,
		/* Optional */
		loadProductFirst: true,
		showLimitList: '24,36,48',
		collapseOnMobileByDefault: false,
		numberFilterTree: 2,
		paginationType: bcSfFilterConfig.custom.pagination == 'infinite_scroll' ? 'infinite' :
						(bcSfFilterConfig.custom.pagination == 'click_to_load' ? 'load_more' : 'default'),
	},
};

const jsonToAttribute = jsonData => JSON.stringify(jsonData).replace(/\x22/g, '&quot;');

// Declare Templates
var bcSfFilterTemplate = {
	// Grid Template
	'productGridItemHtml': '<li class="{{customClass}}" data-product-item tabindex="1">' +
								'{{itemJson}}' +
								'<article id="{{itemHandle}}" class="productitem" data-product-item-content>' +
									'{{itemFavIcon}}' +
									'{{itemLabRecommended}}' +
									'<a class="productitem--image-link" href="{{itemUrl}}" data-product-page-link>' +
                    '<figure class="productitem--image" data-product-item-image>' +
											'{{itemImages}}' +
											'{{itemLabels}}' +
											'{{itemBlurb}}' +
										'</figure>' +
									'</a>' +
									'<div class="productitem--info">' +
										'{{itemSwatchesAlways}}' +
										'{{emphasizePrice}}'  +
										'{{itemVendor}}' +
										'<h2 class="productitem--title">' +
											'<a href="{{itemUrl}}" tabindex="1" data-product-page-link>' +
												'{{itemTitle}}' +
											'</a>' +
        							'<span class="productitem--mlabel">{{itemLabel}}</span>' +
										'</h2>' +
										'{{noEmphasizePrice}}'  +
										'{{itemStock}}' +
										'{{itemReviews}}' +
										'{{itemSwatchesOnHover}}' +
										'{{itemDescription}}' +
									'</div>' +
									'<div class="productitem--actions" data-product-actions>'+
										'{{itemActions}}' +
									'</div>' +
								'</article>' +
								'{{itemQuickShopSettings}}' +
							'</li>',

  // Pagination Template
  'previousActiveHtml': '<li class="pagination--previous"><a class="bc-pagination--item" href="{{itemUrl}}"><span class="pagination--chevron-left" aria-hidden="true"><svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="8" height="6" viewBox="0 0 8 6" > <g fill="currentColor" fill-rule="evenodd"> <polygon class="icon-chevron-down-left" points="4 5.371 7.668 1.606 6.665 .629 4 3.365"/> <polygon class="icon-chevron-down-right" points="4 3.365 1.335 .629 1.335 .629 .332 1.606 4 5.371"/> </g> </svg></span>' + bcSfFilterConfig.label.prev + '</a></li>',
  'previousDisabledHtml': '',
  'nextActiveHtml': '<li class="pagination--next"><a class="bc-pagination--item" href="{{itemUrl}}">' + bcSfFilterConfig.label.next + '<span class="pagination--chevron-right" aria-hidden="true"><svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="8" height="6" viewBox="0 0 8 6" > <g fill="currentColor" fill-rule="evenodd"> <polygon class="icon-chevron-down-left" points="4 5.371 7.668 1.606 6.665 .629 4 3.365"/> <polygon class="icon-chevron-down-right" points="4 3.365 1.335 .629 1.335 .629 .332 1.606 4 5.371"/> </g> </svg></span></a></li>',
  'nextDisabledHtml': '',
  'pageItemHtml': '<li><a class="bc-pagination--item" href="{{itemUrl}}">{{itemTitle}}</a></li>',
  'pageItemSelectedHtml': '<li class="pagination--active"><span class="pagination--item">{{itemTitle}}</span></li>',
  'pageItemRemainHtml': '<li class="pagination--ellipsis"><span class="pagination--item">{{itemTitle}}</span></li>',
  'paginateHtml': '<div class="bc-pagination--container"><ul class="pagination--inner">{{previous}}{{pageItems}}{{next}}</ul></div>',

  // Sorting Template
  'sortingHtml':  '<label class="utils-sortby-title" for="bc-sf-filter-top-sorting-select">' + bcSfFilterConfig.label.sorting + '</label>' +
				  '<div class="utils-sortby-select form-field-select-wrapper no-label">' +
					  '<select id="bc-sf-filter-top-sorting-select" class="form-field form-field-select">{{sortingItems}}</select>' +
					  '<svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="8" height="6" viewBox="0 0 8 6" > <g fill="currentColor" fill-rule="evenodd"> <polygon class="icon-chevron-down-left" points="4 5.371 7.668 1.606 6.665 .629 4 3.365"/> <polygon class="icon-chevron-down-right" points="4 3.365 1.335 .629 1.335 .629 .332 1.606 4 5.371"/> </g> </svg>' +
				  '</div>',

  // Show limit Template
  'showLimitHtml': '<li><span class="utils-showby-title">' + bcSfFilterConfig.label.show_per_page + '</span></li>{{showLimitItems}}',
};

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function (data) {
	/*** Prepare data ***/
	var images = data.images_info;
	// Displaying price base on the policy of Shopify, have to multiple by 100
	var soldOut = !data.available; // Check a product is out of stock
	var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
	var priceVaries = data.price_min != data.price_max; // Check a product has many prices
	/*** End Prepare data ***/

	// Get Template
	var itemHtml = bcSfFilterTemplate.productGridItemHtml;

	// Add custom class
	var customClass = 'productgrid--item imagestyle--' + bcSfFilterConfig.custom.product_grid_image_style;
	if (onSale) customClass += ' productitem--sale';
	if (bcSfFilterConfig.custom.emphasize_price) customClass += ' productitem--emphasis';
	itemHtml = itemHtml.replace(/{{customClass}}/g, customClass);

	var itemImages = '';
	if (images.length > 0) {
		if (images.length > 1 && bcSfFilterConfig.custom.product_grid_show_second_image) {
			itemImages += buildImage(images[1], '100x', 'productitem--image-alternate');
		}
		itemImages += buildImage(images[0], '100x', 'productitem--image-primary');
	} else {
		itemImages += '<img alt="{{itemTitle}}" src="{{itemThumbUrl}}">';
	}
	itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImages);

	// Add Thumbnail
	var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src'], '384x') : bcSfFilterConfig.general.no_image_url;
	itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

	// Add Label
	var itemLabelsHtml = '';
	if (soldOut) {
		itemLabelsHtml += `<span class="productitem--badge badge--soldout" aria-label="${bcSfFilterConfig.label.sold_out}"></span>`;
	} else {
		if (onSale && bcSfFilterConfig.custom.product_sales_badge) {
			var savePrice = data.compare_at_price_min - data.price_min;
			var percentSavePrice = Math.round(savePrice * 100 / data.compare_at_price_max);
			var savePriceHtml = '<span class="money" data-price-money-saved>' + this.formatMoney(savePrice) + '</span>';
			var percentSavePriceHtml = '<span data-price-percent-saved>' + percentSavePrice + '</span>';
			itemLabelsHtml += '<span class="productitem--badge badge--sale" data-badge-sales>';
			switch (bcSfFilterConfig.custom.product_sales_badge_style) {
				case 'percentile':
					itemLabelsHtml += bcSfFilterConfig.label.sale_percentile_html.replace(/{{ saved }}/g, percentSavePriceHtml);
					break;
				case 'money':
					itemLabelsHtml += bcSfFilterConfig.label.sale_money_html.replace(/{{ saved }}/g, this.formatMoney(savePrice));
					break;
				default:
					itemLabelsHtml += bcSfFilterConfig.label.sale;
					break;
			}
			itemLabelsHtml += '</span>';
		}
	}
	itemHtml = itemHtml.replace(/{{itemLabels}}/g, itemLabelsHtml);

	// Lab Recommended Content
	var itemLabRecommendedHtml = '';
  var labRecommendedDeprecated = findMetafieldValue('lab_recommended', 'copy', data.metafields);
  var labRecommended = findMetafieldValue('blurb', 'lab_recommended', data.metafields);
  var blurbMetafieldValue = findMetafieldValue('blurb', 'blurb', data.metafields);
	var isLabRecommended = labRecommended === 'true' || labRecommendedDeprecated;

  if (isLabRecommended) {
		itemLabRecommendedHtml += `
			<svg class="icon-lab-recommended" aria-hidden="true" focusable="false" role="presentation" width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M15 0L17.0696 1.93288L19.6353 0.734152L21.0063 3.21198L23.8168 2.86475L24.355 5.64498L27.1353 6.18322L26.788 8.99371L29.2658 10.3647L28.0671 12.9304L30 15L28.0671 17.0696L29.2658 19.6353L26.788 21.0063L27.1353 23.8168L24.355 24.355L23.8168 27.1353L21.0063 26.788L19.6353 29.2658L17.0696 28.0671L15 30L12.9304 28.0671L10.3647 29.2658L8.99371 26.788L6.18322 27.1353L5.64498 24.355L2.86475 23.8168L3.21198 21.0063L0.734152 19.6353L1.93288 17.0696L0 15L1.93288 12.9304L0.734152 10.3647L3.21198 8.99371L2.86475 6.18322L5.64498 5.64498L6.18322 2.86475L8.99371 3.21198L10.3647 0.734152L12.9304 1.93288L15 0Z" fill="#6AC671"/>
				<path d="M13.9354 18.4009C13.8611 18.8281 13.8426 19.2366 13.8611 19.608C13.9169 20.4623 14.2883 20.9823 15.1611 20.9637C16.1268 20.9452 17.334 19.3852 17.8168 18.5866L17.8354 18.5681C17.7797 18.9766 17.7611 19.3852 17.7797 19.7195C17.8354 20.4252 18.0768 20.8337 18.5968 20.8337C19.3954 20.8152 21.4754 17.8438 22.0696 16.9524C22.1253 16.8595 22.1439 16.7481 22.1439 16.6552C22.1253 16.4324 21.9396 16.1909 21.7354 16.1909C21.6611 16.1909 21.5868 16.2281 21.5311 16.3395C21.0482 17.1195 18.8382 19.9052 18.5597 19.9238C18.5411 19.9238 18.5411 19.9238 18.5411 19.9238C18.4854 19.8866 18.4668 19.7752 18.4482 19.6452C18.4111 19.1809 18.5968 18.0481 18.7825 16.9338C20.7139 13.9438 21.7168 11.4367 21.6054 9.78385C21.5682 9.24529 21.4382 8.76243 21.1039 8.78101C19.7297 8.81815 18.894 12.9781 18.1882 16.5624C17.854 17.1381 17.5382 17.6581 17.2968 17.9923C17.2783 18.0109 17.2597 18.0295 17.2597 18.0666C16.9997 18.4938 15.774 20.0723 15.2726 20.0723C14.8826 20.0723 14.6411 19.8866 14.604 19.348C14.5854 19.1066 14.604 18.7909 14.6783 18.4195C14.9383 17.0081 15.4397 15.0209 16.034 13.2195C16.7397 13.201 17.594 13.1638 17.724 13.1452C17.9282 13.1081 18.0211 12.9224 18.0025 12.7181C17.984 12.4953 17.8354 12.3653 17.594 12.3653C17.5197 12.3653 16.8697 12.4024 16.4054 12.4024C16.6468 11.6781 16.8511 11.0653 16.9625 10.5824C16.9997 10.4153 17.0183 10.3038 16.9997 10.211C16.9811 9.96957 16.8325 9.83957 16.6097 9.83957C16.4425 9.83957 16.3311 9.98814 16.2197 10.3224C16.0525 10.8424 15.8111 11.6038 15.5883 12.4024C14.2697 12.4395 12.6169 12.4953 12.3754 12.4953C12.6169 11.771 12.8212 11.1396 12.9326 10.6567C12.9511 10.4896 12.9883 10.3967 12.9697 10.2853C12.9511 10.0439 12.8026 9.91385 12.5797 9.91385C12.4126 9.91385 12.3012 10.0624 12.1897 10.3967C12.0226 10.9353 11.7626 11.6967 11.5583 12.5324C11.0197 12.551 10.2769 12.5695 9.90546 12.5881C9.66404 12.5881 9.53404 12.7367 9.55261 12.9595C9.57118 13.1638 9.68261 13.3495 9.88689 13.3495C10.2212 13.3495 10.834 13.3124 11.2426 13.3124C11.094 13.7952 10.9455 14.4267 10.7969 14.8909C10.2026 16.5066 8.86548 18.7166 8.19691 19.6823C8.12263 19.7938 8.04834 19.9609 8.04834 20.0538C8.04834 20.3323 8.21548 20.4066 8.40119 20.4066C8.49405 20.4066 8.56833 20.3509 8.62405 20.2766C8.67976 20.1838 9.94261 18.2709 9.99832 18.1966C9.92404 18.6238 9.79404 19.348 9.83118 19.7009C9.88689 20.5552 10.2397 21.0752 11.1312 21.0566C12.0969 21.038 13.304 19.4595 13.7869 18.6609C13.824 18.6052 13.954 18.3452 13.954 18.2895L13.9354 18.4009ZM20.8811 9.74671C20.9925 11.4553 19.5439 14.1667 19.0054 15.1881C19.5439 12.811 20.4354 10.1367 20.8811 9.74671ZM13.2483 18.0852C13.2297 18.1223 13.2297 18.1038 13.1926 18.1781C12.8954 18.6423 11.7069 20.1466 11.224 20.1652C10.834 20.1652 10.5926 19.9795 10.5555 19.4409C10.5369 19.1809 10.574 18.8838 10.6483 18.5123C10.9083 17.0824 11.4097 15.1138 12.0226 13.3124C12.3754 13.3124 13.9169 13.2567 15.2726 13.2381C15.124 13.721 14.9754 14.371 14.8268 14.8167C14.2326 16.4138 13.9169 17.1195 13.2483 18.0852Z" fill="#F8F7F8"/>
			</svg>
			<div class="lab-recommended__content" data-lab-recommended-content>
				<h5 class="lab-recommended__title">${bcSfFilterConfig.label.lab_recommended}</h5>
				<p class="lab-recommended__copy">${blurbMetafieldValue}</p>
				<a class="lab-recommended__link" href="{{itemUrl}}"></a>
			</div>
		`;
	}

  itemHtml = itemHtml.replace(/{{itemLabRecommended}}/g, itemLabRecommendedHtml);

	// Add hover blurb
	var itemBlurbHtml = '';

	if (blurbMetafieldValue && !isLabRecommended) {
		itemBlurbHtml += `<p class="grid-blurb">${blurbMetafieldValue}</p>`;
	}
	itemHtml = itemHtml.replace(/{{itemBlurb}}/g, itemBlurbHtml);

	// Add Price
	var priceHtml = '';
	var classVaries = priceVaries ? 'price--varies' : '';
	var visibleClass = onSale || bcSfFilterConfig.custom.emphasize_price ? 'visible' : '';
	priceHtml += '<div class="productitem--price ' + classVaries + '">';
	// Current price
	priceHtml += '<span class="price--main" data-price>';
	var price = '<span class="money">' + this.formatMoney(data.price_min) + '</span>';
	var priceLabel = '';
	if (onSale || priceVaries) {
		priceLabel += '<span class="price--label">';
		if (onSale) priceLabel += bcSfFilterConfig.label.sale + ' ';
		if (priceVaries) priceLabel += bcSfFilterConfig.label.range + ' ';
		priceLabel += '</span>';
	}
	priceHtml += priceLabel;
	priceHtml += price;
	priceHtml += '</span>';
	// Compare at price
	priceHtml += '<span class="price--compare-at ' + visibleClass + '" data-price-compare-at>';
	var comparePrice = '<span class="money">' + this.formatMoney(data.compare_at_price_min) + '</span>';
	if (onSale) {
		priceHtml += comparePrice;
	} else {
		priceHtml += '<span class="money"></span>';
	}
	priceHtml += '</span>';
	priceHtml += '</div>';
	// Add emphasize price
	var emphasizePriceHtml = '';
	var noEmphasizePriceHtml = '';
	if (bcSfFilterConfig.custom.emphasize_price) {
		emphasizePriceHtml += priceHtml;
	} else {
		noEmphasizePriceHtml += priceHtml;
	}
	itemHtml = itemHtml.replace(/{{emphasizePrice}}/g, emphasizePriceHtml);
	itemHtml = itemHtml.replace(/{{noEmphasizePrice}}/g, noEmphasizePriceHtml);
	itemHtml = itemHtml.replace(/{{itemPrice}}/g, priceHtml);

	// Add vendor
	var itemVendorHtml = '';
	if (bcSfFilterConfig.custom.show_vendor && data.vendor !== '') {
		itemVendorHtml += '<h3 class="productitem--vendor">' + data.vendor + '</h3>';
	}
	itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

  // Growave Reviews
  itemHtml = itemHtml.replace(/{{itemReviews}}/g, reviewGroove(data));

  // Growave Fave Icon
	itemHtml = itemHtml.replace(/{{itemFavIcon}}/g, favIcon(data));

	// Add stock
	var itemStockHtml = '';
	var inventoryPolicyContinue =
		data.selected_or_first_available_variant.inventory_policy === 'continue' &&
		data.selected_or_first_available_variant.inventory_management === 'shopify';
	var itemInventory = data.selected_or_first_available_variant.inventory_quantity;
	var stockThreshold = bcSfFilterConfig.custom.product_low_stock_threshold;

	if (bcSfFilterConfig.custom.product_show_stock_level == 'all') {
		var classes = 'product--stock-level ';
		var text = `Only ${itemInventory} left!`;

		if (itemInventory > stockThreshold || inventoryPolicyContinue) {
			classes += 'stock-level--in-stock';
		} else if (itemInventory > 0 && itemInventory <= stockThreshold) {
			classes += 'stock-level--low-stock';
		} else if (itemInventory <= 0) {
			classes += 'stock-level--no-stock';
			text = bcSfFilterConfig.label.no_stock;
		}

		itemStockHtml += `
			<div class="stock-level--wrapper" data-stock-level>
				<span class="${classes}">
					<span class="stock-level--text">
						${text}
					</span>
				</span>
			</div>
		`;

		if (bcSfFilterConfig.custom.product_hide_high_stock_items && itemInventory > bcSfFilterConfig.custom.product_low_stock_threshold || inventoryPolicyContinue) {
			itemStockHtml = '';
		}
	}
	itemHtml = itemHtml.replace(/{{itemStock}}/g, itemStockHtml);

	// Add swatches
	var itemSwatchesHtml = buildSwatch(data);
	if (bcSfFilterConfig.custom.swatches_product_card_hover == 'on-hover'){
		itemHtml = itemHtml.replace(/{{itemSwatchesAlways}}/g, '');
		itemHtml = itemHtml.replace(/{{itemSwatchesOnHover}}/g, itemSwatchesHtml);
	} else {
		itemHtml = itemHtml.replace(/{{itemSwatchesAlways}}/g, itemSwatchesHtml);
		itemHtml = itemHtml.replace(/{{itemSwatchesOnHover}}/g, '');
	}

	// Add description
	var itemDescriptionHtml = '';
	if (data.body_html){
		var description = jQ('<div></div>').html(data.body_html).text(); // Strips html tags
		itemDescriptionHtml += '<div class="productitem--description">';
		itemDescriptionHtml += '<p>' + (description.length > 150 ? description.substring(0, 150) : description) + '</p>';
		if (description.length > 150){
			itemDescriptionHtml += '<a href="{{itemUrl}}" class="productitem--link" data-product-page-link>' + bcSfFilterConfig.label.view_details + '</a>'
		}
		itemDescriptionHtml += '</div>';
	}
	itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescriptionHtml);

	// Add data json
	var self = this;
	var itemJson = {
		"id": data.id,
		"title": data.title,
		"handle": data.handle,
		"vendor": data.vendor,
		"variants": data.variants,
		"url": self.buildProductItemUrl(data),
		"options_with_values": data.options_with_values,
		"images": data.images,
		"available": data.available,
		"price_min": data.price_min,
		"price_max": data.price_max,
		"compare_at_price_min": data.compare_at_price_min,
		"compare_at_price_max": data.compare_at_price_max
	};
	itemHtml = itemHtml.replace(/{{itemJson}}/g, '<script type="application/json" data-product-data>' + JSON.stringify(itemJson) + '</script>');

	// Add quickBtn
	var itemActionsHtml = buildActions(data);
	itemHtml = itemHtml.replace(/{{itemActions}}/g, itemActionsHtml);
	var titleSanitized = data.title.split(data.vendor + ":").pop();
	// Add main attribute (Always put at the end of this function)
	itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
	itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
	itemHtml = itemHtml.replace(/{{itemTitle}}/g, titleSanitized);
	itemHtml = itemHtml.replace(/{{itemLabel}}/g, findMetafieldValue('mlabel', 'mlabel', data.metafields));
	itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

	var itemQuickShopSettings = '';
  if (bcSfFilterConfig.custom.enable_quick_buy) {
		itemQuickShopSettings += `
			<script type="application/json" data-quick-buy-settings>
				{
					"cart_redirection": ${bcSfFilterConfig.custom.quickshop_product_cart_redirect},
					"money_format": ${bcSfFilterConfig.custom.money_format}
				}
			</script>
		`;
	}

	if (bcSfFilterConfig.custom.enable_quick_look) {
		itemQuickShopSettings += `
			<div
				style="display:none;"
				data-product-quickshop="${data.id}"
				data-product-quickshop-url="${data.url}"
			>
			</div>
		`;
	}

	itemHtml = itemHtml.replace(/{{itemQuickShopSettings}}/g, itemQuickShopSettings);

	return itemHtml;
};

// Build Product List Item
BCSfFilter.prototype.buildProductListItem = function (data) {
	return this.buildProductGridItem(data);
};

function buildActions(data){
	var actionsHtml = '';
	var hasVariants = data.options[0] === 'Default Title' ? false : true;
	var quickLookText = bcSfFilterConfig.label.quick_look_text;
	var spinner = '<svg aria-hidden="true" focusable="false" role="presentation" width="26" height="26" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg" > <g fill-rule="nonzero" fill="currentColor"> <path d="M13 26C5.82 26 0 20.18 0 13S5.82 0 13 0s13 5.82 13 13-5.82 13-13 13zm0-3.852a9.148 9.148 0 1 0 0-18.296 9.148 9.148 0 0 0 0 18.296z" opacity=".29"/><path d="M13 26c7.18 0 13-5.82 13-13a1.926 1.926 0 0 0-3.852 0A9.148 9.148 0 0 1 13 22.148 1.926 1.926 0 0 0 13 26z"/> </g> </svg>';

	if (bcSfFilterConfig.custom.enable_quick_look) {
		var actionClasses = 'productitem--action quickshop-button';
		var quickShopClasses = 'productitem--action-trigger productitem--action-atc button-primary';

		if (bcSfFilterConfig.custom.enable_quick_look == 'desktop') {
			actionClasses += ' productitem-action--desktop';
		}

		var actionEnabledData = `data-variant-id="${data.selected_or_first_available_variant.id}"`;
		actionEnabledData += hasVariants ? ' data-quickshop-trigger="full"' : ' data-quick-buy';

		var actionEnabled = `
			<button
				class="${quickShopClasses}"
				type="button"
				aria-label=""
				${actionEnabledData}
			>
				<span class="atc-button--text">${quickLookText}</span>
				<span class="atc-button--icon">${spinner}</span>
			</button>
		`;

		// TODO: Format product data properly for this to work ch91141
		var actionDisabled = `
			<button
				class="${quickShopClasses} BIS_trigger disabled"
				data-product-data="${jsonToAttribute(data)}"
				type="button"
				data-product-bis
			>
				${bcSfFilterConfig.label.waitlist}
			</button>
		`;

		actionsHtml += `
			<div class="${actionClasses}">
				${data.available ? actionEnabled : actionDisabled}
			</div>
		`;
	}

	return actionsHtml;
}

function buildImage(imageInfo, size, className) {
	if (!imageInfo) {
		imageInfo = {
			src: bcSfFilterConfig.general.no_image_url,
			width: 480,
			height: 480,
			aspect_ratio: 1
		}
	}

	var html = '<img ' +
		'class="' + className + '" ' +
		'alt="{{itemTitle}}" ' +
		'data-rimg-scale="1" ' +
		'data-rimg-template="' + bcsffilter.optimizeImage(imageInfo.src, '{size}') + '" ' +
		'data-rimg-max="' + imageInfo.width + 'x' + imageInfo.height + '" ' +
		'data-rimg-crop ' +
		'data-rimg="lazy" ' +
    	'src="' + bcsffilter.optimizeImage(imageInfo.src, size) + '" ' +
        'srcset="data:image/svg+xml;utf8,<svg%20xmlns=\'http://www.w3.org/2000/svg\'%20width=\''+ imageInfo.width +'\'%20height=\''+ imageInfo.height +'\'></svg>">';

	html += '<div data-rimg-canvas></div>';
	return html;
}

function buildSwatch(data){
	var html = '';
    var swatches = [];
    var swatchValues = [];
    var swatchOptionIndex = 1;
    if (bcSfFilterConfig.custom.swatches_enable && bcSfFilterConfig.custom.swatches_swatch_trigger && !bcSfFilterConfig.custom.swatches_product_page_only){
        var customColors = bcSfFilterConfig.custom.swatches_custom_colors.split('\n');
        data.variants.forEach(function(variant){
            var swatchValue = '';
            variant.options = variant.merged_options; // Use for theme function
            variant.merged_options.forEach(function(merged_option, index){
                var key = merged_option.split(':')[0].trim();
                var value = merged_option.split(':')[1].trim();
                if (key.toLowerCase() == bcSfFilterConfig.custom.swatches_swatch_trigger.toLowerCase() && swatchValues.indexOf(value.toLowerCase()) == -1){
                    swatchValue = value;
                    swatchValues.push(value.toLowerCase());
                    swatchOptionIndex = index + 1;
                }
            })
            if (swatchValue){
                var swatch ='<label>' +
                                '<input class="productitem--swatches-input" type="radio" name="swatch" value="{{swatchValue}}">' +
                                '<div class="productitem--swatches-swatch-wrapper" data-swatch-tooltip="{{swatchValue}}" data-swatch>' +
                                    '<div class="productitem--swatches-swatch">' +
                                        '<div class="productitem--swatches-swatch-inner" '+
                                        'style="background-color:{{backgroundColor}}; background-color:{{customColor}}; background-image:url({{backgroundImage}}); background-size:cover"></div>' +
                                    '</div>' +
                                '</div>' +
                            '</label>';
                var customColor = '';
                customColors.forEach(function(color){
                    if (color.split(':').length == 2){
                        var customColorName = color.split(':')[0].trim().toLowerCase();
                        var customColorValue = color.split(':')[1].trim().toLowerCase();
                        if (customColorName == swatchValue.toLowerCase()){
                            customColor = customColorValue;
                        }
                    }
                })

                var slugifyValue = bcsffilter.slugify(swatchValue);
                var backgroundColor = slugifyValue.split('-').pop();
                var backgroundImage = bcSfFilterMainConfig.general.file_url.split('?')[0] + slugifyValue + '.png';

                swatch = swatch.replace(/{{swatchValue}}/g, swatchValue);
                swatch = swatch.replace(/{{backgroundColor}}/g, backgroundColor);
                swatch = swatch.replace(/{{backgroundImage}}/g, backgroundImage);
                swatch = swatch.replace(/{{customColor}}/g, customColor);
                swatches.push(swatch);
            }
        })

        if (swatchValues.length > 0){
			var html = '';
			if (bcSfFilterConfig.custom.swatches_product_card_hover == 'on-hover'){
				var swatchesCountLabel = swatchValues.length > 1 ? bcSfFilterConfig.label.swatches_count_other : bcSfFilterConfig.label.swatches_count_one;
				swatchesCountLabel = swatchesCountLabel.replace(/{{ count }}/g, swatchValues.length);
				html += '<div class="productitem--swatches-summary">' + swatchesCountLabel + '</div>';
			}
			html +=  '<div class="productitem--swatches productitem--swatches-show-'+ bcSfFilterConfig.custom.swatches_product_card_hover +'" data-swatches>' +
                        '<script type="application/json" data-swatch-data>' +
                          '{' +
                            '"hash": "{{itemDataSha256}}",' +
							'"swatchOptionKey": "{{swatchOptionKey}}",' +
							'"swatchesProductCardHover": "'+ bcSfFilterConfig.custom.swatches_product_card_hover + '"' +
                          '}' +
                        '</script>' +
                        '<form class="productitem--swatches-container" data-swatches-container>' +
                            swatches.join(' ') +
						'</form>' +
						(
						bcSfFilterConfig.custom.swatches_product_card_hover == 'on-hover' ?
						'' :
                        '<div class="productitem--swatches-count-wrapper" data-swatch-count-wrapper>' +
                            '<div class="productitem--swatches-count" data-swatch-count>+</div>' +
						'</div>'
						) +
                    '</div>';

            html = html.replace(/{{swatchOptionKey}}/g, 'option' + swatchOptionIndex);
            html = html.replace(/{{variantsJson}}/g, JSON.stringify(data.variants));
        }
    }

    return html;
}

// Build Pagination
BCSfFilter.prototype.buildPagination = function (totalProduct) {
	// Get page info
	var currentPage = parseInt(this.queryParams.page);
	var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

	// If it has only one page, clear Pagination
	if (totalPage == 1) {
		jQ(this.selector.pagination).html('');
		return false;
	}

	if (this.getSettingValue('general.paginationType') == 'default') {
		var paginationHtml = bcSfFilterTemplate.paginateHtml;

		// Build Previous
		var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
		previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
		paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

		// Build Next
		var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextDisabledHtml;
		nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
		paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

		// Create page items array
		var beforeCurrentPageArr = [];
		for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
			beforeCurrentPageArr.unshift(iBefore);
		}
		if (currentPage - 4 > 0) {
			beforeCurrentPageArr.unshift('...');
		}
		if (currentPage - 4 >= 0) {
			beforeCurrentPageArr.unshift(1);
		}
		beforeCurrentPageArr.push(currentPage);

		var afterCurrentPageArr = [];
		for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
			afterCurrentPageArr.push(iAfter);
		}
		if (currentPage + 3 < totalPage) {
			afterCurrentPageArr.push('...');
		}
		if (currentPage + 3 <= totalPage) {
			afterCurrentPageArr.push(totalPage);
		}

		// Build page items
		var pageItemsHtml = '';
		var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
		for (var iPage = 0; iPage < pageArr.length; iPage++) {
			if (pageArr[iPage] == '...') {
				pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
			} else {
				pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
			}
			pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
			pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
		}
		paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

		jQ(this.selector.pagination).html(paginationHtml);
	}
};

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function () {
	if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
		jQ(this.selector.topSorting).html('');

		var sortingArr = this.getSortingList();
		if (sortingArr) {
			// Build content
			var sortingItemsHtml = '';
			for (var k in sortingArr) {
				sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
			}
			var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			jQ(this.selector.topSorting).html(html);

			// Set current value
			jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
		}
	}
};

// Build Show Limit
BCSfFilter.prototype.buildFilterShowLimit = function () {
	if (bcSfFilterTemplate.hasOwnProperty('showLimitHtml')) {
		jQ(this.selector.topShowLimit).html('');

		var numberList = this.getSettingValue('general.showLimitList');
		if (numberList != '') {
			// Build content
			var showLimitItemsHtml = '';
			var arr = numberList.split(',');
			for (var k = 0; k < arr.length; k++) {
				if (arr[k] == this.queryParams.limit) {
					showLimitItemsHtml += '<li><a class="utils-showby-item active" href="' + arr[k] + '">' + arr[k] + '</a></li>';
				} else {
					showLimitItemsHtml += '<li><a class="utils-showby-item" href="' + arr[k] + '">' + arr[k] + '</a></li>';
				}
			}
			var html = bcSfFilterTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, showLimitItemsHtml);
			jQ(this.selector.topShowLimit).html(html);
		}
	}
};

BCSfFilter.prototype.buildShowLimitEvent = function () {
	var _this = this;
	jQ(this.selector.topShowLimit + ' li a').click(function (e) {
		onInteractWithToolbar(e, 'limit', _this.queryParams.limit, jQ(this).attr('href'));
	})
};

// Build Breadcrumb
BCSfFilter.prototype.buildBreadcrumb = function (colData, apiData) {
	if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
		var colInfo = colData.collection;
		var delimiter = '<span class="breadcrumbs-delimiter" aria-hidden="true"><svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="8" height="5" viewBox="0 0 8 5"><path fill="currentColor" fill-rule="evenodd" d="M1.002.27L.29.982l3.712 3.712L7.714.982 7.002.27l-3 3z"/></svg></span>';
		var breadcrumbHtml = '<a href="/">' + bcSfFilterConfig.label.breadcrumb_home + '</a> ';
		breadcrumbHtml += delimiter;
		breadcrumbHtml += ' <span>' + colInfo.title + '</span>';
		jQ('.breadcrumbs-container').html(breadcrumbHtml);
	}
};

// Build Display type event
BCSfFilter.prototype.buildDisplayTypeEvent = function () {
	// Fix heigh issue on list view
	jQ('#bc-sf-filter-products li[data-product-item]').css('height', 'initial').css('min-height', 'initial').css('max-height', 'initial');

	// Bind events
	var _this = this;
	jQ(_this.selector.topDisplayType + ' button').off('click');
	jQ(_this.selector.topDisplayType + ' button').on('click', function (e) {
		var newValue = jQ(this).attr('data-display-type');
		sessionStorage.setItem('data-display-type', newValue);
		jQ(this).parent().children('button').removeClass('active');
		jQ(this).addClass('active');
		if (newValue == 'list-view') {
			jQ('.productgrid--outer').removeClass('productgrid-gridview');
			jQ('.productgrid--outer').addClass('productgrid-listview');

			// Fix heigh issue on list view
			jQ('#bc-sf-filter-products li[data-product-item]').each(function(){
				var height = jQ(this).height() + 'px';
				jQ(this).css('height', height).css('min-height', height).css('max-height', height);
			});
		} else {
			jQ('.productgrid--outer').removeClass('productgrid-listview');
			jQ('.productgrid--outer').addClass('productgrid-gridview');

			// Fix heigh issue on list view
			jQ('#bc-sf-filter-products li[data-product-item]').css('height', 'initial').css('min-height', 'initial').css('max-height', 'initial');
		}
	});
};

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function (data, eventType) {
	var self = this;
	var total_products = data.length;
	var count = 0;
    if (window.bcImage){
		bcImage.init('[data-rimg="lazy"]', {
			round: 1
		});
	}
	if (bcSfFilterConfig.custom.enable_quick_buy || bcSfFilterConfig.custom.enable_quick_look) {
		jQ(self.getSelector('products')).find(".productgrid--item").each(function (e) {
			var _this = this;
			var url = jQ(this).find(".productitem--image-link").eq(0).attr("href");
			jQ.ajax({
				type: "GET",
				url: url + '?view=bc-sf-quickview',
				success: function (data) {
					if (jQ(_this).find('.productitem-quickshop').length == 0){
						jQ(_this).append(data);
						count++;
						if (count == total_products || count == total_products - 1) {
							buildTheme();
						}
					}
				}
			});
		});
	} else {
		buildTheme();
	}
};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function (data, eventType) {
	// Build search page breadcrumbs
	if (this.isSearchPage()) {
		var content = '';
		var searchTerm = this.escape(this.getSearchTerm());
		if (searchTerm != null) {
			content = bcSfFilterConfig.label.search_breadcrumbs_count_other || '';
			if (data.total_product == 1) {
				content = bcSfFilterConfig.label.search_breadcrumbs_count_one || '';
			} else if (data.total_product == 0) {
				content = bcSfFilterConfig.label.search_breadcrumbs_count_zero || '';
			}
			content = content.replace(/{{ count }}/g, data.total_product).replace(/{{ terms }}/g, searchTerm);
			content = content.replace(/&lt;strong&gt;/g, '<strong>').replace(/&lt;\/strong&gt;/g, '</strong>');
		}
		jQ('.breadcrumbs-container span:last-child').html(content);
		jQ('.breadcrumbs-container span').css('display', 'inline-block');
	} else {
		var content = '';
		content = bcSfFilterConfig.label.collection_item_count_other || '';
		if (data.total_product == 1) {
			content = bcSfFilterConfig.label.collection_item_count_one || '';
		}
		content = content.replace(/{{ count }}/g, data.total_product)
		jQ('.collection-item-count').html(content);
	}
};

function buildTheme(){
	// In superstore.js or superstore.min.js:
    // - Add "var bcSections; var bcStaticCollection;" to the begining
    // - Find "var sections = new Sections();", replace like below:

    // var sections = new Sections();
	// bcSections = sections;
	// bcStaticCollection = StaticCollection_StaticCollection;
	// sections.register....

	// Reinit theme
	if (window.bcSections && window.bcStaticCollection){
		bcSections.unbind('static-collection');
		bcSections.register('static-collection', function (section) {
			return new bcStaticCollection(section);
		});
	}
	if (window.bcImage){
		bcImage.init('[data-rimg="lazy"]', {
			round: 1
		});
	}

	var display = sessionStorage.getItem('data-display-type');
	if (display == 'list-view'){
		jQ('[data-display-type="list-view"]').click();
	} else {
		jQ('[data-display-type="grid-view"]').click();
	}
}

// Start Growave Integration
function reviewGroove(data) {
  // Add ssw review
  var ssw_review_enabled = bcSfFilterConfig.custom.ssw_review_enabled;
  var ssw_count_rate = 0;
  var ssw_avg_rate = 0;
  var ssw_unite_reviews = bcSfFilterConfig.custom.ssw_unite_reviews;
  var sswReviewsHtml = '';
  var ssw_unite_rate_data_key;
  var ssw_rate_data_key = data.id + '_rate_data';
  if (ssw_unite_reviews == 1) {
    var ssw_unite_product_ids = bcSfFilterConfig.custom.ssw_unite_product_ids.split(',');
    if (ssw_unite_product_ids.indexOf(data.id) !== -1) {
      ssw_unite_rate_data_key = data.id + '_unite_rate_data';
      if (bcsffilter.getProductMetafield(data, 'ssw', ssw_unite_rate_data_key) !== null) {
        ssw_rate_data_key = ssw_unite_rate_data_key;
      }
    }
  }
  if (bcsffilter.getProductMetafield(data, 'ssw', 'review') !== null) {
    var ssw_rate_data = bcsffilter.getProductMetafield(data, 'ssw', 'review');
    ssw_rate_data = JSON.parse(ssw_rate_data);
    ssw_count_rate = ssw_rate_data['count'];
    ssw_avg_rate = ssw_rate_data['avg'];
  }
  sswReviewsHtml += '<div class="ssw-widget-avg-rate-listing ssw-stars ssw-stars-large ';
  if (ssw_count_rate == 0) {
    sswReviewsHtml += 'ssw-hide';
  }
  sswReviewsHtml += '">';
  var ssw_j = Math.floor(ssw_avg_rate);
  for (var i = 1; i <= ssw_j; i++) {
    sswReviewsHtml += '<i class="ssw-icon-star"></i>\n';
  }
  var ssw_rate_last_star = 5 - ssw_avg_rate;
  var ssw_y = Math.floor(ssw_rate_last_star);
  var ssw_x = ssw_avg_rate - ssw_j;
  if (ssw_x > 0.74) {
    sswReviewsHtml += '<i class="ssw-icon-star"></i>\n';
  } else {
    if (ssw_x > 0.24) {
      sswReviewsHtml += '<i class="ssw-icon-star-half-alt"></i>\n';
    } else {
      if (ssw_x > 0) {
        ssw_y = ssw_y + 1;
      }
    }
  }
  for (var j = 0; j < ssw_y; j++) {
    sswReviewsHtml += '<i class="ssw-icon-star-empty"></i>\n';
  }
  sswReviewsHtml += '<span class="ssw-review-count">(' + ssw_count_rate + ')</span>\n';
  sswReviewsHtml += '</div>';
  return sswReviewsHtml;
}

function favIcon(data) {
  var favHtml = '<div class="ssw-faveiticon sswfaveicon' + data.id + '">';
  favHtml += ' <i data-product-id="' + data.id + '" data-count="0" class="ssw-icon-heart-o ssw-fave-icon ssw-wishlist-element ssw-not-synch"'
  favHtml += 'title="Add to Wishlist"';
  favHtml += 'data-params= \'{"product_id":"' + data.id + '","event":"fave_button","page":"product_profile"} \'></i>';
  favHtml += '<span class="faves-count">...</span></div>';

  return favHtml;
}
// End Growave Integration

BCSfFilter.prototype.prepareFilterParams = function(params, eventType) {
	// Get collection id
	if (!this.queryParams.hasOwnProperty('collection_scope')) {
		if (!this.isSearchPage()) {
			params.collection_scope = parseInt(this.collectionId);
			if (eventType == 'history') {
				var historyData = History.getState().data;
				if (historyData.hasOwnProperty('param') && historyData.param.hasOwnProperty('collection_scope')) {
					params.collection_scope = this.collectionId = parseInt(historyData.param.collection_scope);
				} else {
					params.collection_scope = this.collectionId = parseInt(bcSfFilterConfig.general.collection_id);
				}
			}
		} else {
			params.collection_scope = 0;
		}
	} else {
		params.collection_scope = Array.isArray(this.queryParams.collection_scope) ? this.queryParams['collection_scope'][0] : this.queryParams['collection_scope'];
	}
	// Get product/variant available or not
	if (this.getSettingValue('general.availableAfterFiltering') == true) {
		params.product_available = this.checkExistFilterOptionParam() === true ? true : this.productAvailable;
		params.variant_available = this.checkExistFilterOptionParam() === true ? true : this.variantAvailable;
	} else {
		params.product_available = this.productAvailable;
			params.variant_available = this.variantAvailable;
	}
	// Get Tag value
	if (typeof this.collectionTags !== 'undefined' && this.collectionTags !== null) params.tag = this.collectionTags;
	// Display filter option items even they return no product
	if (this.getSettingValue('general.showOutOfStockOption')) params.zero_options = true;
	// Build Filter tree or not
	params.build_filter_tree = (typeof eventType !== 'undefined' && this.imutableFilterTree.indexOf(eventType) > -1) ? false : true; // Except events of elements in filter tree, all remaining events do not rebuild filter tree
	// Enable cache when request params doest not have filter option values, "page" param equal to 1 and "sort" param equal to default sorting
	params.check_cache = (this.checkExistFilterOptionParam() === false && params['page'] == 1 && params['sort'] == this.defaultSorting && params['limit'] == this.getSettingValue('general.limit') && !this.isSearchPage() && !this.isVendorPage() && !this.isTypePage()) ? true : false;
	// Turn on price mode
	if (this.getSettingValue('general.priceMode') != '') params['price_mode'] = this.getSettingValue('general.priceMode');
	// Tag mode
	if (this.getSettingValue('general.tagMode') != '') params['tag_mode'] = this.getSettingValue('general.tagMode');
	// Availability Sorting
	if (this.getSettingValue('general.sortingAvailableFirst')) params.sort_first = 'available';
	// Vendor page: Get Vendor param
	if (this.isVendorPage() && params.hasOwnProperty('q')) {
		var vendorParam = this.getSettingValue('general.vendorParam');
		// params[vendorParam] = [params['q'].replace(/\+/g, ' ')];
		params[vendorParam] = [params['q']];
		delete params['q'];
	}
	// Type page: Get Type param
	if (this.isTypePage() && params.hasOwnProperty('q')) {
		var typeParam = this.getSettingValue('general.typeParam');
		params[typeParam] = [params['q']];
		delete params['q'];
	}
  
	if (this.isSearchPage()) {
		params.sort_first = 'available';
	}

	return params;
};


BCSfFilter.prototype.prepareSearchParams = function(params, eventType) {
    if (this.isSearchPage()) {
        params['q'] = this.getSearchTerm();
        if (this.searchTermKey != 'q') delete params[this.searchTermKey];
        var enableFuzzy = this.getSettingValue('search.enableFuzzy');
        if (enableFuzzy) params.fuzzy = !enableFuzzy;
        if (params['q'].length > 4) params.fuzzy = enableFuzzy;
        if (this.getSettingValue('search.reduceMinMatch') !== false) {
            params.reduce_min_match = this.getSettingValue('search.reduceMinMatch');
        }
        if (this.getSettingValue('search.fullMinMatch')) params.full_min_match = true;
        if (this.getSettingValue('general.sortingAvailableFirst')) params.sort_first = 'available';
        if (this.getSettingValue('search.enablePlusCharacterSearch')) params.enable_plus_character_search = true;
    }
    return params;
};

BCSfFilter.prototype.prepareSuggestionParams = function(searchTerm, eventType) {
    var params = {};
    params.shop = this.shopDomain;
    params.t = new Date().getTime();
    if (!this.getSettingValue('search.enableDefaultResult')) params.enable_default_result = false;
    var enableFuzzy = this.getSettingValue('search.enableFuzzy');
    if (enableFuzzy !== true ) params.fuzzy = !enableFuzzy;
  
    if (searchTerm.length > 4) params.fuzzy = enableFuzzy;
  
    if (this.getSettingValue('search.fullMinMatch')) params.full_min_match = true;
    if (this.getSettingValue('search.reduceMinMatch') !== false) {
      params.reduce_min_match = this.getSettingValue('search.reduceMinMatch');
    }
    if (this.getSettingValue('search.enablePlusCharacterSearch')) params.enable_plus_character_search = true;
    // Get product/variant available or not
    if (this.getSettingValue('search.productAvailable') == true) params.product_available = true;
    // Limit
    var blocks = this.getSettingValue('search.suggestionBlocks');
    var k;
    var blocksLength = blocks.length;
    for (k = 0; k < blocksLength; k++) {
        var id = blocks[k]['type'].slice(0, -1);
        params[id + '_limit'] = blocks[k]['number'];
    }
    params['dym_limit'] = this.getSettingValue('search.suggestionDymLimit');
    // Skip fields
    var skipFields = this.getSettingValue('search.skipFields');
    if (skipFields.length > 0) param.skipFields = skipFields;
    params.callback = 'BCSfSuggestionCallback';
    params.event_type = eventType;
    // Suggest types
    var suggestionTypes = eventType == 'suggest_dym' ? ['products'] : this.getSettingValue('search.suggestionTypes');
    params.suggest_types = suggestionTypes;
    params = this.setThirdPartyAppParams(params);
    return params;
};

// Build Default layout
BCSfFilter.prototype.buildDefaultElements=function(){var isiOS=/iPad|iPhone|iPod/.test(navigator.userAgent)&&!window.MSStream,isSafari=/Safari/.test(navigator.userAgent),isBackButton=window.performance&&window.performance.navigation&&2==window.performance.navigation.type;if(!(isiOS&&isSafari&&isBackButton)){var self=this,url=window.location.href.split("?")[0],searchQuery=self.isSearchPage()&&self.queryParams.hasOwnProperty("q")?"&q="+self.queryParams.q:"";window.location.replace(url+"?view=bc-original"+searchQuery)}};

function customizeJsonProductData(data) {for (var i = 0; i < data.variants.length; i++) {var variant = data.variants[i];var featureImage = data.images.filter(function(e) {return e.src == variant.image;});if (featureImage.length > 0) {variant.featured_image = {"id": featureImage[0]['id'],"product_id": data.id,"position": featureImage[0]['position'],"created_at": "","updated_at": "","alt": null,"width": featureImage[0]['width'], "height": featureImage[0]['height'], "src": featureImage[0]['src'], "variant_ids": [variant.id]}} else {variant.featured_image = '';};};var self = bcsffilter;var itemJson = {"id": data.id,"title": data.title,"handle": data.handle,"vendor": data.vendor,"variants": data.variants,"url": self.buildProductItemUrl(data),"options_with_values": data.options_with_values,"images": data.images,"images_info": data.images_info,"available": data.available,"price_min": data.price_min,"price_max": data.price_max,"compare_at_price_min": data.compare_at_price_min,"compare_at_price_max": data.compare_at_price_max};return itemJson;};
BCSfFilter.prototype.prepareProductData = function(data) {var countData = data.length;for (var k = 0; k < countData; k++) {data[k]['images'] = data[k]['images_info'];if (data[k]['images'].length > 0) {data[k]['featured_image'] = data[k]['images'][0]} else {data[k]['featured_image'] = {src: bcSfFilterConfig.general.no_image_url,width: '',height: '',aspect_ratio: 0}}data[k]['url'] = '/products/' + data[k].handle;var optionsArr = [];var countOptionsWithValues = data[k]['options_with_values'].length;for (var i = 0; i < countOptionsWithValues; i++) {optionsArr.push(data[k]['options_with_values'][i]['name'])}data[k]['options'] = optionsArr;if (typeof bcSfFilterConfig.general.currencies != 'undefined' && bcSfFilterConfig.general.currencies.length > 1) {var currentCurrency = bcSfFilterConfig.general.current_currency.toLowerCase().trim();function updateMultiCurrencyPrice(oldPrice, newPrice) {if (typeof newPrice != 'undefined') {return newPrice;}return oldPrice;}data[k].price_min = updateMultiCurrencyPrice(data[k].price_min, data[k]['price_min_' + currentCurrency]);data[k].price_max = updateMultiCurrencyPrice(data[k].price_max, data[k]['price_max_' + currentCurrency]);data[k].compare_at_price_min = updateMultiCurrencyPrice(data[k].compare_at_price_min, data[k]['compare_at_price_min_' + currentCurrency]);data[k].compare_at_price_max = updateMultiCurrencyPrice(data[k].compare_at_price_max, data[k]['compare_at_price_max_' + currentCurrency]);}data[k]['price_min'] *= 100, data[k]['price_max'] *= 100, data[k]['compare_at_price_min'] *= 100, data[k]['compare_at_price_max'] *= 100;data[k]['price'] = data[k]['price_min'];data[k]['compare_at_price'] = data[k]['compare_at_price_min'];data[k]['price_varies'] = data[k]['price_min'] != data[k]['price_max'];var firstVariant = data[k]['variants'][0];if (getParam('variant') !== null && getParam('variant') != '') {var paramVariant = data[k]['variants'].filter(function(e) {return e.id == getParam('variant')});if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0]} else {var countVariants = data[k]['variants'].length;for (var i = 0; i < countVariants; i++) {if (data[k]['variants'][i].available) {firstVariant = data[k]['variants'][i];break}}}data[k]['selected_or_first_available_variant'] = firstVariant;var countVariants = data[k]['variants'].length;for (var i = 0; i < countVariants; i++) {var variantOptionArr = [];var count = 1;var variant = data[k]['variants'][i];var variantOptions = variant['merged_options'];if (Array.isArray(variantOptions)) {var countVariantOptions = variantOptions.length;for (var j = 0; j < countVariantOptions; j++) {var temp = variantOptions[j].split(':');data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1];data[k]['variants'][i]['option_' + temp[0]] = temp[1];variantOptionArr.push(temp[1])}data[k]['variants'][i]['options'] = variantOptionArr}data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100;data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100}data[k]['description'] = data[k]['content'] = data[k]['body_html'];if (data[k].hasOwnProperty('original_tags') && data[k]['original_tags'].length > 0) {data[k]['tags'] = data[k]['original_tags'].slice(0);}data[k]['json'] = customizeJsonProductData(data[k]);}return data;};
